import { CookieCollection, getUrlParameter, Log } from './script';
import * as log from 'loglevel';
import * as _ from 'lodash';
// @ts-ignore
import moment from 'moment';

const categoryTemplate = _.template($('#category-template').html());
const productTemplate = _.template($('#product-template').html());
const collapseTemplate = _.template($('#collapse-template').html());

import { HeroApiBookingProductAddon } from './models';
import { getCurrentRoomId } from './script-select-room';

function getCurrentRoom() {
  const rcStr = getUrlParameter('rc');
  if (!rcStr) {
    console.error('rc not set');
    return undefined;
  }
  return parseInt(rcStr);
}

const onReviewCartPreviousClick = function(e) {
  e.preventDefault();

  const rc = getCurrentRoom();
  if (!rc) {
    return;
  }

  const roomMaxStr = getUrlParameter('roommax');
  if (!roomMaxStr) {
    console.error('roommax not set');
    return;
  }
  const roomMax = parseInt(roomMaxStr);

  // if not first room, go to review cart of previous room
  if (rc && rc > 1) {
    window.location.href =
      './review-cart?rc=' + (rc - 1) + '&roommax=' + roomMax;
    return;
  }

  const selectedRooms = CookieCollection.SelectedRooms.get();
  if (!selectedRooms) {
    log.error('productSearch not set');
    return;
  }

  const productSearch = CookieCollection.ProductSearch.get();
  if (!productSearch) {
    log.error('productSearch not set');
    return;
  }

  // get last room
  const lastRoom = _.find(selectedRooms, function(r) {
    return r.room == roomMax;
  });
  if (!lastRoom) {
    console.error('last room not found');
    return;
  }

  // redirect to select room
  const branch = productSearch.branchId;
  window.location.href =
    './select-room?s=' +
    lastRoom.checkIn +
    '&e=' +
    lastRoom.checkOut +
    '&branch=' +
    branch +
    '&rc=' +
    roomMax +
    '&roommax=' +
    roomMax;
};

// Update pricing when addon added to cart
const updatepricing = function() {
  log.debug('updatePricing');
  let price = 0;
  $('.addonadd').each(function() {
    const inCart = $(this).data('incart');
    if (inCart == true) {
      const thisItemPrice = $(this).data('price');
      const thisItemQuantity = $(this).data('quantity');
      price = price + parseInt(thisItemPrice) * parseInt(thisItemQuantity);
      // console.log(price)
    }
  });

  const rc = getUrlParameter('rc');
  if (!rc) {
    log.error('rc should not be undefined');
    return;
  }
  const currentRoomIndex = parseInt(rc);
  const selectedRooms = CookieCollection.SelectedRooms.get() || [];

  // filter addons to show only rooms last than current room index
  const addons = _.filter(CookieCollection.Addons.get() || [], function(a) {
    return currentRoomIndex > a.room;
  });

  const totalAddonsPrice = _.sumBy(addons, function(a) {
    log.debug(a);
    return a.price * a.quantity;
  });
  const totalRoomsPrice = _.sumBy(selectedRooms, function(r) {
    return r.price;
  });

  log.debug('totalAddonsPrice:', totalAddonsPrice);
  log.debug('totalRoomsPrice', totalRoomsPrice);
  price = price + totalAddonsPrice + totalRoomsPrice;
  log.debug('price', price);

  $('#TotalCost span').text('$' + price.toFixed(2));
  $('.mobileTotal').text('$' + price.toFixed(2));

  $('#reviewTotal').text(price);

  $('#TotalCost span').text('$' + price.toFixed(2));
};

function showCart() {
  Log.group('showCart');

  try {
    const rc = getCurrentRoom();
    if (!rc) {
      return;
    }

    const selectedRooms = CookieCollection.SelectedRooms.get();
    if (!selectedRooms) {
      log.error('selectedRooms should not be undefined');
      return;
    }
    let existingAddons = CookieCollection.Addons.get();
    if (!existingAddons) {
      existingAddons = [];
    }
    const productSearch = CookieCollection.ProductSearch.get();
    if (!productSearch) {
      log.error('productSearch should not be undefined');
      return;
    }

    let orderTotal = _.sumBy(selectedRooms, function(r) {
      return r.price;
    });
    orderTotal += _.sumBy(existingAddons, function(a) {
      return a.price * a.quantity;
    });

    // {module_webapps id="40850" filter="all" resultsPerPage="10" hideEmptyMessage="true" rowCount="" sortType="weight"}

    // populate addons
    const $wrapper = $('#cartrowwrapper');

    const $categories = $('.category-data');
    _.forEach($categories, (category, index) => {
      const $x = $(category);

      if (index === 1) {
        $wrapper.append(collapseTemplate());
      }

      const id = $x.data('id');
      $wrapper.append(
        categoryTemplate({
          id: id,
          name: $x.data('name')
        })
      );

      if (index === 0) {
        setTimeout(() => {
          $(`#category-container-${id}`).fadeIn();
        }, 100);
      }
    });

    const $products = $('.product-data');
    _.forEach($categories, (category) => {
      const $category = $(category);
      _.forEach($products.toArray(), (product) => {
        const $product = $(product);
        if ($category.data('id') !== $product.data('category-id')) {
          return;
        }
        const data = {
          name: $product.data('name'),
          price: $product.data('price'),
          priceDescription: $product.data('priceDescription'),
          displayTitle: $product.data('display-title'),
          useHeroInventory: $product.data('useHeroInventory'),
          qtySelect: $product.data('qtySelect'),
          featureImage: $product.data('feature-image'),
          productId: $product.data('product-id'),
          category: $product.data('category'),
          addonName: $product.data('name')
        };
        log.debug($category.data('id'));
        $(`#category-${$category.data('id')}`).append(productTemplate(data));
      });
    });

    if (orderTotal == 0) {
      $('#norooms').show();
      $('.totalblock').hide();
    }

    $('#reviewTotal').text(orderTotal);
    $('#TotalCost span').text('$' + orderTotal.toFixed(2));
  } finally {
    Log.groupEnd();
  }
}

function handleOnAddonAddClick(target: HTMLElement) {
  const currentRoom = getCurrentRoom();
  if (!currentRoom) {
    return;
  }
  const $target = $(target);
  const $parent = $($target.closest('.addonadd'));
  if (!$parent) {
    log.error('.addonadd should not be undefined');
    return;
  }
  // const quantityStr = $parent.find('input').val() as string | undefined;
  //const quantityStr = $parent.find('select').val() as string | undefined;
  const valueStr = $parent.find('select').val() as string | undefined;
  log.error('valueStr is: ', valueStr);
  const quantityStr = valueStr?.split('|')[0];
  const addOnPrice = valueStr?.split('|')[1];
  const eventDateTime = valueStr?.split('|')[2];
  //log.error('quantityStr is: ', quantityStr);
  //log.error('addOnPrice is: ', addOnPrice);
  //log.error('eventDateTime is: ', eventDateTime);
  const quantity = !quantityStr ? 0 : parseInt(quantityStr);
  const incart = $parent.data('incart');
  // $parent.find('.btn').toggle();
  // $parent.find('.input-group').toggle();
  // $parent.find('.select').toggle();
  //if (!incart) {
  if(quantity > 0) {
  $parent.data('incart', true);
    $parent.data('quantity', quantity);
    const p = $parent.data('price');
    $parent
      .find('.remove')
      .text('Remove ' + quantity + ' - $' + parseInt(p) * quantity);

    let addons = CookieCollection.Addons.get();
    if (!addons) {
      addons = [];
    }

    const heroId = $parent.data('id');
    const thisAddon: HeroApiBookingProductAddon = {
      productId: heroId,
      rateCode: '',
      productRateCode: eventDateTime as string,
      addonName: $parent.data('addonname'),
      price: $parent.data('price'),
      room: currentRoom,
      quantity: $parent.data('quantity'),
      paxId: [],
      paxRoomId: [],
      questions: []
    };

    if (!thisAddon.addonName) {
      log.error('addonName should not be undefined');
      return;
    }

    if (!thisAddon.quantity) {
      log.error('quantity should not be undefined');
      return;
    }

    if (!thisAddon.price) {
      log.error('price should not be undefined');
      return;
    }

    $(`[data-product-question][data-product-id="${heroId}"]`).each(
      (index, element) => {
        const question = $(element).val() as string;
        thisAddon.questions.push(question);
      }
    );
    
    for (let i = 0; i < addons.length; i++) {
      if (addons[i].room === currentRoom) {
        if (addons[i].productId == heroId) {
          addons.splice(i, 1);
        }
      }
    }

    addons.push(thisAddon);
    CookieCollection.Addons.set(addons);
    log.debug(thisAddon);
  } else {
    $parent.data('incart', false);
    $parent.data('quantity', 0);
    const heroId = $parent.data('id');
    const addons = CookieCollection.Addons.get() || [];
    for (let i = 0; i < addons.length; i++) {
      if (addons[i].room === currentRoom) {
        if (addons[i].productId == heroId) {
          addons.splice(i, 1);
        }
      }
    }

    CookieCollection.Addons.set(addons);
    log.debug(addons);

    // $parent.find('select').val(1);
  }

  $(parent)
    .find('p strong')
    .text();
  updatepricing();
}

export function ReviewCart() {
  const existingAddons = CookieCollection.Addons.get() || [];
  log.debug('existingAddons', existingAddons);

  showCart();


  $('.btn-decrement').on('click', (e) => {
    const $target = $(e.target);

    // return if it is disabled
    if ($target.parent('child').hasClass('d-none')) {
      return;
    }

    validate();
  });
  $('.btn-increment').on('click', (e) => {
    const $target = $(e.target);

    // return if it is disabled
    if ($target.parent('child').hasClass('d-none')) {
      return;
    }

    validate();
  });

  
  $('.removeroom').on('click', function() {
    const parentRow = $(this).closest('.cartrow');
    $('#removeRoom').modal('show');
    $('#roomholder').val($(parentRow).data('room'));
  });

  $('.addon-qty-select').on('change', function(e) {
    e.preventDefault();

    handleOnAddonAddClick(e.target);
  });

      //  $('.btn-decrement').on('click', (e) => {
      //   const $target = $(e.target);

      // });
      // $('.btn-increment').on('click', (e) => {
      //   const $target = $(e.target);

      // });


  $('#removeRoom .btn-danger').on('click', function() {
    const roomNumberStr = $('#roomholder').val() as string | undefined;
    if (!roomNumberStr) {
      log.error('roomholder shall not be undefined');
      return;
    }
    const roomNumber = parseInt(roomNumberStr);
    const selectedRooms = CookieCollection.SelectedRooms.get() || [];
    const $cartRowWrapperDiv = $('#cartrowwrapper > div');
    $cartRowWrapperDiv.fadeOut();
    $cartRowWrapperDiv.remove();

    for (let i = 0; i < selectedRooms.length; i++) {
      if (selectedRooms[i].room == roomNumber) {
        selectedRooms.splice(i, 1);
      }
    }
    CookieCollection.SelectedRooms.set(selectedRooms);
    const $removeRoom = $('#removeRoom');
    $removeRoom.modal('hide');

    showCart();
  });

  // handle continue button event
  $('#toCheckout').on('click', function(e) {
    e.preventDefault();
    const $target = $(e.target);
    if ($target.hasClass('disabled')) {
      log.debug('checkout button is already clicked');
      return;
    }
    $target.addClass('disabled');
    const href = __URL_PROCESS_PAYMENT__;
    if (!href) {
      console.error('__URL_PROCESS_PAYMENT__ is undefined');
      return;
    }
    window.location.href = href;
  });

  // handle 'Previous' button click event
  $('.btn.previous').on('click', null, null, onReviewCartPreviousClick);

  $('#btn-show-more').on('click', (e) => {
    e.preventDefault();

    const $more = $('#btn-show-more .more');
    const $less = $('#btn-show-more .less');
    if (!$less.is(':visible')) {
      $('.category-container:nth-child(n + 2)').fadeIn();
      $more.hide();
      $less.show();
    } else {
      $('.category-container:nth-child(n + 2)').fadeOut();
      $more.show();
      $less.hide();
    }
  });

  $('.details-modal-button').on('click', (e) => {
    e.preventDefault();

    $(e.target).modal('show');
  });

  $('.modal-product-btn-close').on('click', (e) => {
    e.preventDefault();

    const target = $(e.target).data('target');
    $(target).modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  });

  if (existingAddons) {
    // apply selected addons
    setTimeout(() => {
      const currentRoomId = getCurrentRoomId();
      if (!currentRoomId) {
        return;
      }

      _.forEach($('.addonadd').toArray(), (addon, index) => {
        const $addon = $(addon);
        const existingAddon = _.find(
          existingAddons,
          (x) => x.room === currentRoomId && x.productId === $addon.data('id')
        );
        if (!existingAddon) {
          $addon.data('incart', false);
          $addon.data('quantity', 0);
          return;
        }
        $addon.data('incart', true);
        $addon.data('quantity', existingAddon.quantity);
        // $addon.find('.btn').toggle();
        // $addon.find('select').val(existingAddon.quantity);
        // $addon.find('select').toggle();
        $addon.find('select option[value^=\'' + existingAddon.quantity + '\']').attr('selected', 'selected');
       
        // $addon
        //   .find('.remove')
        //   .text(
        //     `Remove ${existingAddon.quantity} - $${existingAddon.price *
        //       existingAddon.quantity}`
        //   );
      });

      // for (var addon of existingAddons) {

      // console.log(addon)
      // $(addon).find('select').val(existingaddons[i].quantity)
      // $(addon).find('.add').click()
      // console.log(parent)

      // $(addon).find('.btn').toggle();
      // $(parent).find('select').toggle();

      // var p = $(parent).data('price');
      // $(parent)
      //   .find('.remove')
      //   .text('Remove ' + existingAddons[i].quantity + ' - $' + parseInt(p) * existingAddons[i].quantity);
      // }
      updatepricing();
    }, 100);
  }
}
